import {TRowFilter} from '../../../components/Table/Table'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterDelveryOrders} from '../../../redux/slices/filterSlices'
import {memo} from 'react'
import {Selection} from '../../../components/Selection'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import DatePickerV2 from 'src/components/DatePickerV2/DatePickerV2'
import {useTranslation} from 'react-i18next'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterDeliveryOrders: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization()

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterDelveryOrders({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <Selection
          placeholder={t('MANAGEMENT_DO_TABLE.COL_SALES_ORG')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(value: any) => handleChange({sales_org_code: value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_DISTRIBUTOR')}
          value={filter?.customer_code ?? ''}
          onChange={({target}) => handleChange({customer_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_DISTRIBUTOR_NAME')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_SO_NUMBER')}
          value={filter?.so_number ?? ''}
          onChange={({target}) => handleChange({so_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_DO_NUMBER')}
          value={filter?.do_number ?? ''}
          onChange={({target}) => handleChange({do_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_DELIVERY_ITEM')}
          value={filter?.delivery_item ?? ''}
          onChange={({target}) => handleChange({delivery_item: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_PGI_DATE')}
          startDate={filter?.do_date ?? ''}
          isSelectsRange={false}
          onChange={({startDate}) => handleChange({do_date: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_MATERIAL_NUMBER')}
          value={filter?.material_number ?? ''}
          onChange={({target}) => handleChange({material_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Jenis-Produk')}
          value={filter?.material_group ?? ''}
          onChange={({target}) => handleChange({material_group: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_PLANT')}
          value={filter?.plant ?? ''}
          onChange={({target}) => handleChange({plant: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_PLANT_DESC')}
          value={filter?.plant_desc ?? ''}
          onChange={({target}) => handleChange({plant_desc: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('MANAGEMENT_DO_TABLE.COL_QUANTITY')}
          value={filter?.qty ?? ''}
          onChange={({target}) => handleChange({qty: target.value})}
        />
      </td>
    </TRowFilter>
  )
})
